import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { useParams } from 'react-router-dom';
import { Table, Image, Header, Pagination, Icon, Label } from 'react-frontier';
import { User } from '../../Classes';
import { addCommas, cropString } from '@tempu/components/Util';
import { formatAddress } from '../../Util';
import moment from 'moment';
import classNames from 'classnames';
import API from '../../API';

const PAGE_SIZE = 5;

var UserInfo = ()=>{
	var { setTitle } = useTitle(); 
	var params = useParams<{ user_id: string }>();
	var user_id = parseInt(params?.user_id);
	var [loadError, setLoadError] = useState<string>(null);
	var [user, setUser] = useState<User>(null);
	var [loading, setLoading] = useState<boolean>(false);
	var [page, setPage] = useState<number>(0);

	useEffect(()=>{
		setTitle('Usuario')
		API.getUser(user_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setUser(res.data);
		}).catch(e=>{
			return setLoadError('Hubo un error inesperado cargando la información de usuario. (LCL-1)');
		});
		getSummary();
	}, []);

	var getSummary = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getMoneySummary(offset, PAGE_SIZE).then(res=>{
			if(res.error) return setLoadError(res.message);
			setUser(prevUser => ({
				...prevUser,
				summary: res.data.summary,
				payments: res.data.payments,
			}));
		}).catch(err=>{
			setLoadError('Hubo un error inesperado cargando tu estado de cuenta (LCL-ACMNY-1)');
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		getSummary(page);
	}

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!user || !user.summary){
		return <Header loading text='Cargando datos' />;
	}
	
	return <div className='tp user-info-screen'>
		<div className='container'>
			<div className="avatar">
				<Image src={user?.image} fallbackComponent={(
					<i className='user icon' />
				)} />
			</div>
			<Table
				title='Información'
				details
				data={[
					['ID', user.user_id],
					['Nombre', `${(user.first_name + ' ' + user.last_name).toUpperCase()}`],
					['Creacion', moment.unix(user.date_created).format('DD/MMM/YY HH:mm')],
					['Estatus', <div className={classNames("fr label", {
						green: user.onboarded && !user.banned,
						yellow: !user.onboarded && !user.banned,
						red: user.banned
					})}>
						{user.banned ? 'Baneado' : user.onboarded ? 'Activo' : 'Inactivo'}
					</div>],
					['Correo electrónico', user.email],
					['Teléfono', user.phone],
					['CURP', user.curp],
					['RFC', user.rfc || 'Sin Información'],
					['Dirección', formatAddress(user.location)]
				]}
			/>
		</div>
		<Table
			title='Pagos'
			headers={['Pago', 'Empleo', 'Puesto', 'Fecha', 'Metodo','', 'Cantidad', 'Estatus']}
			collapsingIndexes={[0, 3, 4, 5, 6]}
			footer={user.payments.length >= PAGE_SIZE || page !== 0 ? (
				<Table.Row>
					<Table.Cell colSpan={8}>
						<div style={{ textAlign: 'right' }}>
							<Pagination page={page} onPageChange={onPageChange} />
						</div>
					</Table.Cell>
				</Table.Row>
			) : null}
		>
			{loading ? <Table.Row><Table.Cell colSpan={7}><Header centered loading text={'Cargando Datos.'}/></Table.Cell></Table.Row> : user.payments.length === 0 ? <Table.Row><Table.Cell colSpan={7} centered style={{ fontSize: 14, fontWeight: 'bold'}}>No se encontraron registros.</Table.Cell></Table.Row> :
				user.payments.map(p=> <Table.Row>
					<Table.Cell>{p.payment_id}</Table.Cell>
					<Table.Cell>{cropString(p.posting_name, 32, true)}</Table.Cell>
					<Table.Cell>{p.job_name}</Table.Cell>
					<Table.Cell>{moment.unix(p.date_paid || p.date_created).format('DD/MMM/YY HH:mm')}</Table.Cell>
					<Table.Cell colSpan={2}>{p.account_id ? (
							<div>
								<Icon name={p.clabe ? 'landmark' : 'credit-card'} /> **{p.clabe || p.card_number}
							</div>
						) : (
							<div>
								<Icon name="exclamation-triangle" /> Sin cuenta
							</div>
						)}
					</Table.Cell>
					<Table.Cell>{addCommas(p.amount)}</Table.Cell>
					<Table.Cell>
						<Label 
							size='small' 
							color={p.paid ? 'green' : (p.account_id ? 'orange' : 'blue')}
						>
							{p.paid ? 'Pagado' : (p.account_id ? 'Procesando' : 'Pendiente')}
						</Label>
					</Table.Cell>
			</Table.Row>)}
		</Table>
		
	</div>
}

export default UserInfo;